import { render, staticRenderFns } from "./PayoutRequests.vue?vue&type=template&id=1707bf33&scoped=true&"
import script from "./PayoutRequests.vue?vue&type=script&lang=js&"
export * from "./PayoutRequests.vue?vue&type=script&lang=js&"
import style0 from "./PayoutRequests.vue?vue&type=style&index=0&id=1707bf33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1707bf33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1707bf33')) {
      api.createRecord('1707bf33', component.options)
    } else {
      api.reload('1707bf33', component.options)
    }
    module.hot.accept("./PayoutRequests.vue?vue&type=template&id=1707bf33&scoped=true&", function () {
      api.rerender('1707bf33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/PayoutRequests.vue"
export default component.exports